import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { forwardRef, useContext, useState, useEffect, useImperativeHandle } from 'react';
import { RicosContext } from 'ricos-context';
import Tooltip from 'wix-rich-content-common/libs/Tooltip';
import { s as styles, M as MentionAvatar } from '../MentionAvatar-68852c85.js';
import 'wix-rich-content-ui-components';
import '../style-inject.es-e7b07dd7.js';
import '../icons/AvatarIcon.js';

const MentionList = forwardRef((props, ref) => {
  const { languageDir } = useContext(RicosContext) || {};
  const [selectedIndex, setSelectedIndex] = useState(0);
  const selectItem = (index) => {
    if (props.items[index]) {
      props.command(props.items[index]);
    }
  };
  const upHandler = () => {
    setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length);
  };
  const downHandler = () => {
    setSelectedIndex((selectedIndex + 1) % props.items.length);
  };
  const enterHandler = () => {
    selectItem(selectedIndex);
  };
  useEffect(() => setSelectedIndex(0), [props.items]);
  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (event.key === "ArrowUp") {
        upHandler();
        return true;
      }
      if (event.key === "ArrowDown") {
        downHandler();
        return true;
      }
      if (event.key === "Enter") {
        enterHandler();
        return true;
      }
      return false;
    }
  }));
  const hasEllipsis = (name) => {
    const charactersLimit = 23;
    return name.length > charactersLimit;
  };
  return props.items.length ? /* @__PURE__ */ React.createElement("div", { dir: languageDir, className: styles.mention_list }, props.items.map((item, i) => {
    const tooltipContent = hasEllipsis(item.name) ? item.name : null;
    return /* @__PURE__ */ React.createElement(Tooltip, { key: i, content: tooltipContent, place: "top" }, /* @__PURE__ */ React.createElement(
      "div",
      {
        key: i,
        className: classNames(styles.mention_item, {
          [styles.mention_item_selected]: i === selectedIndex
        }),
        onMouseOver: () => setSelectedIndex(i),
        onClick: () => selectItem(i)
      },
      /* @__PURE__ */ React.createElement(MentionAvatar, { src: item == null ? void 0 : item.avatar, alt: item.name }),
      /* @__PURE__ */ React.createElement("span", null, item.name)
    ));
  })) : null;
});
MentionList.propTypes = {
  items: PropTypes.array,
  command: PropTypes.func
};

export { MentionList as default };
//# sourceMappingURL=MentionList.js.map
